"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FotClientAdapter = void 0;
const RestClient_1 = require("../cutil/RestClient");
const ErrorUtil_1 = require("../api/ErrorUtil");
const Eventbus_1 = require("../cutil/Eventbus");
const UnauthorizedMsg_1 = require("../msg/UnauthorizedMsg");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class FotClientAdapter {
    constructor(baseUrl, authStore, projectStore) {
        this.baseUrl = baseUrl;
        this.authStore = authStore;
        this.projectStore = projectStore;
    }
    errorHandler(error) {
        if (error instanceof RestClient_1.RestResponse) {
            // 提前注入错误处理函数，会被 API 的 parseError 重写
            error.parseError(res => {
                const errorFromApi = ErrorUtil_1.ErrorUtil.parseRestResponse(res);
                return errorFromApi || ErrorUtil_1.ErrorUtil.defaultErrorMsg;
            });
            if (error.status === 401) {
                this.authStore.logout();
                Eventbus_1.eventbus.emit(new UnauthorizedMsg_1.UnauthorizedMsg());
            }
        }
    }
    get headers() {
        const brainToken = this.authStore.state.brainToken;
        const guestToken = this.authStore.state.guestToken;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let header = {
            "X-Brain-User-Tz": tz,
        };
        if (!(0, is_blank_1.default)(brainToken)) {
            header["Authorization"] = `token ${brainToken}`;
        }
        else if (!(0, is_blank_1.default)(guestToken)) {
            // view builder在未登录用户情况下的Google搜索api需要token
            header["Brain-Guest-User-Key"] = guestToken;
        }
        const attrIndexer = this.projectStore.attrIndexer;
        if (!(0, is_blank_1.default)(attrIndexer)) {
            header["X-Brain-Imagica-Id"] = attrIndexer;
        }
        return header;
    }
    get contentType() {
        return RestClient_1.RestContentType.json;
    }
    isCustomApiType(headers) {
        return false;
    }
}
exports.FotClientAdapter = FotClientAdapter;
